import { render } from "./AccidentsTable.vue?vue&type=template&id=ee546b04"
import script from "./AccidentsTable.vue?vue&type=script&lang=js"
export * from "./AccidentsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__